import { setListenersFromSelector } from '../functions/listeners';
import { querySelector, querySelectorAll } from '../functions/querySelectors';
import debounce from '../functions/debounce';

const TOOLTIP_CLASS = 'w-tooltip';
const TOOLTIP_PRESHOW_CLASS = 'w-tooltip--preshow';
const TOOLTIP_SHOW_CLASS = 'w-tooltip--show';
const TOOLTIP_INIT_CLASS = 'wt-init';
const TOOLTIP_INIT2_CLASS = 'wt2-init';
const INNER_CLASS = 'w-tooltip__inner';
const ARROW_CLASS = 'w-tooltip__arrow';
const POSITION_CHECKED_CLASS = 'js-fixed';
const HOVER_CLASS = 'w-tooltip--hover';

let windowResize = function() {
  let items = querySelectorAll(`.${POSITION_CHECKED_CLASS}`);

  items.forEach((item) => {
    item.classList.remove(POSITION_CHECKED_CLASS);
    item.classList.remove(TOOLTIP_PRESHOW_CLASS);
    resetMargin(item);

    if (item.classList.contains(TOOLTIP_SHOW_CLASS)) {
      tooltipMouseEnter({}, item);
    }
  });
};

let resetMargin = function(element) {
  let inner = querySelector(`.${INNER_CLASS}`, element);
  inner.style.removeProperty('margin-left');
};

let checkTooltipPosition = function(element, inner) {
  let bounding = inner.getBoundingClientRect();

  //check na osu Y
  if (bounding.y < 0) {
    inner.classList.add('w-tooltip__inner--bottom');
  }

  //check na osu X
  if (bounding.x < 0) {
    inner.style.marginLeft = `${(bounding.x) * -1}px`;
  }
  else if (bounding.x + bounding.width > document.body.clientWidth) {
    inner.style.marginLeft = `${(document.body.clientWidth - (bounding.x + bounding.width))}px`;
  }

  element.classList.add(POSITION_CHECKED_CLASS);
};

let createInner = function(element) {
  let title = element.getAttribute('title');
  let inner = document.createElement('div');

  inner.classList.add(INNER_CLASS);
  inner.textContent = title;

  element.appendChild(inner);
  element.removeAttribute('title');
  return inner;
};

let createArrow = function(element) {
  let arrow = document.createElement('div');

  arrow.classList.add(ARROW_CLASS);

  element.appendChild(arrow);
  return arrow;
};

let tooltipMouseEnter = function(event = {}, tooltip = null) {
  tooltip = tooltip !== null ? tooltip : this;

  let inner = querySelector(`.${INNER_CLASS}`, tooltip);
  let arrow = querySelector(`.${ARROW_CLASS}`, tooltip);

  tooltip.classList.add(HOVER_CLASS);

  if (!inner) {
    inner = createInner(tooltip);
  }

  if (!arrow) {
    arrow = createArrow(tooltip);
  }

  tooltip.classList.add(TOOLTIP_PRESHOW_CLASS);

  if (!tooltip.classList.contains(POSITION_CHECKED_CLASS)) {
    checkTooltipPosition(tooltip, inner);
  }

  setTimeout(function() {
    if (tooltip.classList.contains(HOVER_CLASS)) {
      tooltip.classList.add(TOOLTIP_SHOW_CLASS);
    }
  }, 100);
};

let tooltipMouseLeave = function() {
  this.classList.remove(TOOLTIP_SHOW_CLASS, HOVER_CLASS);
};

export default function() {
  setListenersFromSelector(
    `.${TOOLTIP_CLASS}`,
    TOOLTIP_INIT_CLASS,
    tooltipMouseEnter,
    true,
    'mouseenter'
  );

  setListenersFromSelector(
    `.${TOOLTIP_CLASS}`,
    TOOLTIP_INIT2_CLASS,
    tooltipMouseLeave,
    true,
    'mouseleave'
  );

  window.addEventListener('resize', debounce(windowResize, 250));
}
